export const itemsWrapperSx = {
  '> a, > button': {
    py: 3,
    px: 2,
  },
};

export const menuProps = {
  w: '100%',
  pl: { base: 2, md: 8 },
  fontSize: 'sm',
  fontWeight: 'bold',
  gap: { base: 2, lg: 3, xl: 4 },
  justifyItems: 'flex-end',
  justify: 'flex-end',
  sx: itemsWrapperSx,
};

export const lightProps = {
  bgColor: 'white',
  color: 'gray.900',
};
export const darkProps = {
  bgColor: 'gray.900',
  color: 'white',
};
